import { RouteRecordRaw } from 'vue-router';
// import { RouterView } from 'vue-router';

export const lidlpreiseRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/LidlPreiseLayout.vue'),
    meta: { scope: 'lidlpreise', title: 'EW Lidl Preise' },
    children: [
      { path: '', name: 'lidlpreise.preise', component: () => import('../pages/PreiseView.vue') },
      { path: '/preis/:landkz', name: 'lidlpreise.preis.laender', component: () => import('../pages/PreisLaenderView.vue'), props: true },
      {
        path: '/preis/:landkz/:artikelid',
        name: 'lidlpreise.preis.land.artikel',
        component: () => import('../pages/PreisLandArtikelView.vue'),
        props: true,
      },
      { path: '/listungsuebersichten', name: 'lidlpreise.listungsuebersichten', component: () => import('../pages/ListungsuebersichtenView.vue') },
      { path: '/artikel', name: 'lidlpreise.artikel', component: () => import('../pages/ArtikelView.vue') },
      { path: '/artikel/edit/positionen', name: 'lidlpreise.artikel.edit.pos', component: () => import('../pages/EditArtikelPosView.vue') },
      { path: '/laender', name: 'lidlpreise.laender', component: () => import('../pages/LaenderView.vue') },
      { path: '/laender/edit/positionen', name: 'lidlpreise.laender.edit.pos', component: () => import('../pages/EditLandPosView.vue') },
    ],
  },
];
